<template>
	<v-app
		:style="cssVars"
		v-if="$route.path.includes('/auth')"
		class="guest-layout-wrapper"
		style="display: flex"
	>
		<v-main class="wrapper">
			<div class="section-container">
				<div class="left-section">
					<img alt="login_icon" :src="LoginIcon" />
					<div class="text-overlay">
						<p class="text">The #1 Mobile Engagement Solution for Communities.</p>
					</div>
				</div>
				<div class="right-section" :style="{backgroundColor: rightSideBarBackgroundColor}">
					<slot></slot>
				</div>
			</div>
		</v-main>
	</v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import { isUndefined } from 'lodash'
import LoginIcon from '@/assets/images/img-login.svg'

export default {
	data: () => ({
		LoginIcon
	}),
	computed: {
		...mapGetters('auth', ['isAuthenticated']),
		...mapGetters('settings', ['styles']),
		...mapGetters('app', ['initRoute']),

		cssVars() {
			const {
				navigation_bar_tint: navigationBarTint,

				welcome_background: welcomeBackground,
				button_sign_up: buttonSignUpColor,
				button_login_background: buttonLoginBackground,
				button_login: buttonLoginColor,
				button_main_background: buttonMainBackground,
				button_main: buttonMainTextColor,
				text_button_tint: textButtonTint,
				link: linkColor
			} = this.styles || {}

			return {
				'--accent-color': navigationBarTint,

				'--login-background-color': '#ffffff',
				'--welcome-background-color': welcomeBackground,

				'--welcome-button-signup-color': buttonSignUpColor,
				'--welcome-button-login-background': buttonLoginBackground,
				'--welcome-button-login-color': buttonLoginColor,
				'--button_main_background': buttonMainBackground,
				'--button_main_text_color': buttonMainTextColor,
				'--text_button_tint': textButtonTint,
				'--link': linkColor,
			}
		},
		rightSideBarBackgroundColor() {
			if (this.$route.name === 'welcome') {
				return this.cssVars['--welcome-background-color']
			}

			if (this.$route.name === 'login') {
				return this.cssVars['--login-background-color']
			}

			return '#ffffff';
		}
	},
	watch: {
		isAuthenticated(val, oldVal) {
			if ( isUndefined(oldVal) ) return

			if ( val ) {
				this.$router.push(this.initRoute ? this.initRoute : {name: 'threads'})
			}
		},
	},
}
</script>
<style lang="scss">
.section-container {
	display: flex;
	height: 100vh;
}
.left-section {
	flex: 1;
	background-color: var(--accent-color);
	display: flex;
	align-items: flex-end;
	justify-content: center;
	position: relative;
}
.text-overlay {
	position: absolute;
	top: 40%;
	left: 50%;
	transform: translate(-50%, -50%);
	max-width: 470px;
	width: 100%;
	margin-bottom: 40px;
}
.text {
	color: rgb(255, 255, 255);
	font-size: 36px;
	font-family: Montserrat, sans-serif;
	font-weight: bold;
}
.right-section {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
}
@media (max-width: 780px) {
	.left-section {
		display: none !important;
	}
}
</style>
